import React, { Component } from "react";
import Sidebar from "./SideBar/Sidebar";
import { Switch, BrowserRouter, Route } from "react-router-dom";
import PreLoginComponent from "./Login/PreLoginComponent";
import ErrorBoundary from "./ErrorBoundary";
import { connect } from "react-redux";
import crypto from "crypto";
class App extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  UNSAFE_componentWillMount() {
    if (localStorage.getItem("role")) {
      try {
        let mykey = crypto.createDecipher("aes-128-cbc", "mypassword");
        let mystr = mykey.update(localStorage.getItem("role"), "hex", "utf8");
        mystr += mykey.final("utf8");
        this.props.addRole(mystr);
        this.handlePermission(mystr);
        if (window.location.pathname !== localStorage.getItem("path")) {
          localStorage.setItem("path", window.location.pathname);
          localStorage.setItem("rows", 10);
        }
      } catch (error) {
        console.log(error);
        localStorage.clear();
        window.location = "/";
      }
    }
  }
  handlePermission = (role) => {
    let userSiteFunctionality = false;
    let CTUpload = true;
    let analysisUpload = false;
    let analysisReciept = true;
    let treatmentPlan = false;
    let additionalTreatmentPlan = false;
    let treatmentPlanUpload = false;
    let treatmentPlanReciept = true;
    // let trialFunction = false;
    if (role === "ADMIN") {
      userSiteFunctionality = true;
      analysisUpload = true;
      treatmentPlan = true;
      additionalTreatmentPlan = true;
      treatmentPlanUpload = true;
      // trialFunction = true;
    } else if (role === "PHYSICIAN") {
      treatmentPlan = true;
      additionalTreatmentPlan = true;
    } else if (role === "ASSISTANT") {
    } else if (role === "SALESREP") {
    }
    let obj = {
      USER_SITE_FILE_PERMISSION: userSiteFunctionality,
      CT_UPLOAD_PERMISSION: CTUpload,
      ANALYSIS_UPLOAD_PERMISSION: analysisUpload,
      ANALYSIS_RECEIPT_PERMISSION: analysisReciept,
      TREATMENT_PLAN_PERMISSION: treatmentPlan,
      ADDITIONAL_TREATMENT_PLAN_PERMISSION: additionalTreatmentPlan,
      TREATMENT_PLAN_UPLOAD_PERMISSION: treatmentPlanUpload,
      TREATMENT_PLAN_RECEIPT_PERMISSION: treatmentPlanReciept,
    };
    this.props.UpdatePermission(userSiteFunctionality);
    this.props.HandlePermission(obj);
  };
  componentWillReceiveProps = (nextProps) => {
    // console.log("Checkkkkk");

    localStorage.setItem("path", window.location.pathname);
  };
  render() {
    return (
      <div className="App">
        <ErrorBoundary>
          <BrowserRouter>
            <Switch>
              {localStorage.getItem("token") && localStorage.getItem("name") ? (
                <React.Fragment>
                  {/* <Route path="/Email" component={Sidebar} /> */}
                  <Route path="/" component={Sidebar} />

                  {/* <Redirect to="/" /> */}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Route path="/" component={PreLoginComponent} />

                  {/* <Redirect to="/" /> */}
                </React.Fragment>
              )}
            </Switch>
          </BrowserRouter>
        </ErrorBoundary>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    addRole: (data) => {
      dispatch({ type: "Role", payload: data });
    },
    UpdatePermission: (data) => {
      dispatch({ type: "User_Site_File_Permission", payload: data });
    },
    HandlePermission: (data) => {
      dispatch({ type: "Permission", payload: data });
    },
  };
};
export default connect(null, mapDispatchToProps)(App);
// export default App;
